import { FC } from "react";
import { CpyName } from "../types/entity-names";

/**
 * CpyOptions provides input fields for options, if they are defined for the
 * operation matching the dstEntityName and srcEntityName pair.
 */
export function CpyOptions({
  destinationEntityName,
  sourceEntityName,
  options,
  onOptionsChange,
}: {
  destinationEntityName: CpyName;
  sourceEntityName: CpyName;
  options?: unknown;
  onOptionsChange: (options: unknown) => void;
}) {
  const dst = intoFromMapping[destinationEntityName];
  if (!dst) {
    return null;
  }
  const optComp = intoFromMapping[destinationEntityName][sourceEntityName];
  if (!optComp) {
    return null;
  }

  return optComp({ options, onOptionsChange });
}

type OptionsProps = {
  options?: unknown;
  onOptionsChange: (options: unknown) => void;
};

const intoFromMapping: Record<string, Record<string, FC<OptionsProps>>> = {
  "gsm.htz.offer": {
    "gsm.htz.offer": NoOptions,
  },
};

function NoOptions() {
  return null;
}
